import {useContext, useEffect} from 'react';
import {UserRoleProvider} from '@/context/UserRole/UserRoleProvider';
import {UserRoleContext} from '@/context/UserRole/UserRoleContext';
import {Template} from '@/pages/Template';
import {Outlet} from 'react-router-dom';
import {AuthContext} from '@/context/Auth/AuthContext';
import {PageError403} from '@/pages/Errors/403';

export const ProtectedRoutes = () => {
  const {isReady, isAuthenticated, handleLogin} = useContext(AuthContext);

  useEffect(() => {
    if (isReady && !isAuthenticated) {
      handleLogin('redirect');
    }
  }, [isReady, isAuthenticated, handleLogin]);

  // isAuthenticated already implies the access token is persisted, so nothing
  // renders (and no authenticated API calls fire) before the token is ready.
  if (!isReady || !isAuthenticated) {
    return null;
  }

  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  );
};

const ProtectedRoutesContent = () => {
  const {isReady, isAuthorized} = useContext(UserRoleContext);

  if (!isReady) {
    return null;
  }

  return isAuthorized ? <Outlet /> : <PageError403 />;
};
